import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/voucher-category";

export const pagingVoucherCategory = (searchObject) => 
    axios.post(API_PATH + "/search-by-page", searchObject);

export const getVoucherCategoryById = (voucherCategoryId) => 
    axios.get(API_PATH + "/get-by-id/" + voucherCategoryId);

export const saveVoucherCategory = (voucherCategory) => 
    axios.post(API_PATH + "/save-or-update", voucherCategory);

export const deleteVoucherCategory = (voucherCategoryId) => 
    axios.delete(API_PATH + "/mark-delete/" + voucherCategoryId);
